import { gql, useMutation } from "@apollo/client";

import {
  GetTimestreamDataQuery,
  GetTimestreamDataQueryVariables,
  updateTimestreamDataInput,
  UpdateTimestreamDataMutation,
  UpdateTimestreamDataMutationVariables,
} from "../../API";
import { ParsedResultItem } from "../../pages/data-hub/components/models/common/hooks/useGetEventsTableRows";
import { UPDATE_TIMESTREAM_DATA } from "../operations/mutations";

export const useUpdateTimestreamData = () => {
  const [updateTimestreamDataMutation, { data, loading }] = useMutation<
    UpdateTimestreamDataMutation,
    UpdateTimestreamDataMutationVariables
  >(UPDATE_TIMESTREAM_DATA);

  const updateTimestreamData = async (
    rowId: string,
    input: updateTimestreamDataInput,
    queryInput: GetTimestreamDataQueryVariables
  ) => {
    return await updateTimestreamDataMutation({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        if (data?.updateTimestreamData) {
          try {
            const queryVariables: GetTimestreamDataQueryVariables = {
              input: {
                ...queryInput.input,
                customerId: queryInput.input?.customerId ?? "",
                model: queryInput.input?.model ?? "",
                nextToken:
                  queryInput.input?.offset === 0
                    ? null
                    : queryInput.input?.nextToken,
                offset: queryInput.input?.offset,
              },
            };

            const existingData = cache.readQuery<
              GetTimestreamDataQuery,
              GetTimestreamDataQueryVariables
            >({
              query: gql`
                query GetTimestreamData($input: TimestreamDataInput!) {
                  getTimestreamData(input: $input)
                }
              `,
              variables: queryVariables,
            });

            if (existingData) {
              const parsedExistingData = JSON.parse(
                existingData.getTimestreamData as string
              );

              const updatedData = parsedExistingData.body.map(
                (item: ParsedResultItem) => {
                  if (item.id === rowId) {
                    return {
                      ...item,
                      feedback: input.feedback,
                      mitigatedRisk: input.mitigatedRisk,
                    };
                  }

                  return item;
                }
              );

              cache.writeQuery({
                query: gql`
                  query GetTimestreamData($input: TimestreamDataInput!) {
                    getTimestreamData(input: $input)
                  }
                `,
                variables: queryVariables,
                data: {
                  getTimestreamData: JSON.stringify({
                    ...parsedExistingData,
                    body: updatedData,
                  }),
                },
              });
            }
          } catch (error) {
            console.error("Error while parsing updated Timestream data", error);
          }
        }
      },
    });
  };

  return { updateTimestreamData, data, loading };
};
